import React, { useCallback } from "react";
import Avatar, { AvatarSize } from '../Avatar/Avatar';
import { dateToNiceString } from "../../../helpers/dateToNiceString";
import { INotification } from "../../../common/api_interfaces/notifications/IRespNotification";
import { EntityType } from "../../../common/enums/TypeOfChange";

interface NotificationBlockProps {
    notification: INotification;
    onCheckViewed: (ids: number[]) => Promise<void>;
    onGoToEntity: (id: number, entityId: number, entityType: EntityType, messageId?: number) => void;
    getMentionInText: (content: string) => React.ReactNode;
}

const NotificationBlock: React.FC<NotificationBlockProps> = React.memo(({ 
    notification, 
    onCheckViewed, 
    onGoToEntity,
    getMentionInText 
}) => {
    const handleClick = useCallback(() => {
        onCheckViewed([notification.id]);
    }, [notification.id, onCheckViewed]);

    const handleGoTo = useCallback(() => {
        onGoToEntity(
            notification.id, 
            notification.entityId, 
            notification.entityType, 
            notification.messageId
        );
    }, [notification, onGoToEntity]);

    const contentToDesc = notification?.changeData?.newData?.[0]?.value || "";
    const mentionContent = getMentionInText(contentToDesc);

    return (
        <div 
            className={`${notification.viewed ? "" : "mention__block--current__not--viewed"} mention__block--current`} 
            onClick={handleClick}
        >
            <div className='mention__block--current__img'>
                <Avatar userId={notification.createdBy.id} size={AvatarSize.s}/>
            </div>
            <div className='mention__block--current__body'>
                <div className='mention__block--current__name'>
                    <a>{`${notification.createdBy.name} ${notification.createdBy.surname}`}</a>
                    <a className='mention__block--current__name--gray'>
                        {dateToNiceString(new Date(notification.createdAt), "month dd, yyyy hh:mm")}
                    </a>
                </div>
                <div className='mention__block--current__markdown'>
                    <div className='mention__block--current__markdown--block'>
                        {mentionContent || (
                            <div dangerouslySetInnerHTML={{ __html: contentToDesc }} />
                        )}
                    </div>
                    <div className='mention__block--current__markdown--text'>
                        <a 
                            className='mention__block--current__markdown--text__go--to' 
                            onClick={handleGoTo}
                        >
                            Перейти
                        </a>
                    </div>
                </div>
            </div>
            {!notification.viewed && (
                <div className='mention__block--current__read'>
                    <div className='mention__block--current__read--point'></div>
                </div>
            )}
        </div>
    );
});

NotificationBlock.displayName = 'NotificationBlock';

export default NotificationBlock;